module.exports = __webpack_public_path__ + "static/media/helsinki-23.996c6b4e.jpg";